import { Card, Col, Container, Row } from "reactstrap";
import { Apps, Bookmarks } from "../../../constants";
import Sidebar from "./sideBar";
import Tabs from "./tabs";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

// This component renders the main content area for bookmark system. It includes sidebar, tabs, and content area.
const BookmarkContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Bookmarks} parent={Apps} />
      <Container fluid>
        <div className="message-wrap bookmark-wrap">
          <Row>
            <Sidebar />
            <Col xl="9" md="12" className="box-col-12">
              <div className="mail-right-bar bookmark-tabcontent">
                <Card className="message-body radius-left">
                  <div className="ps-0">
                    <Tabs />
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default BookmarkContainer;
